import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SVG from "react-inlinesvg";
import * as actions from "../_redux/DashboardAction";
import { redirectToPages } from "../../_helpers/Helpers";
import { toAbsoluteUrl } from "../../_metronic/_helpers";

export function DashboardPage() {
  // Getting curret state of Dashboard Details from store (Redux)
  const dispatch = useDispatch();
  const { currentActiveTerm, actionsLoading, isSuccess, type, dashboardData } = useSelector(
    (state) => ({
      //actionsLoading: state.dashboard.actionsLoading,
      isSuccess: state.dashboard.isSuccess,
      type: state.dashboard.type,
      currentActiveTerm: state.auth.user.currentActiveTerm,
      dashboardData: state.dashboard.dashboardData
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getDashboardData());
    return () => dispatch(actions.cleanDashboardState());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);
  
  const { todayStudentCount, thisWeekStudentCount, thisMonthStudentCount, totalStudentCount, nextTermStudentCount } = dashboardData.studentCounts;

  return (
    <div className="row">
      <div className="col-4">
        <div className={`card card-custom card-stretch gutter-b`}>
          
          {/* Header */}
          <div className="card-header border-0">
            <h3 className="card-title font-weight-bolder text-dark">Kesin Kayıtlı Öğrenci Sayısı</h3>
          </div>

          {/* Body */}
          <div className="card-body pt-0">
            <div className="d-flex align-items-center mb-1 bg-light-success rounded p-5">
              <span className="svg-icon svg-icon-success mr-5 svg-icon-lg">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                ></SVG>
              </span>

              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">
                  Bugün
                </span>
              </div>

              <span className="font-weight-bolder text-success py-1 font-size-lg">
                {todayStudentCount}
              </span>
            </div>

            <div className="d-flex align-items-center bg-light-success rounded p-5 mb-1">
              <span className="svg-icon svg-icon-success mr-5 svg-icon-lg">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                ></SVG>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">
                  Son 10 Gün
                </span>
              </div>

              <span className="font-weight-bolder text-success py-1 font-size-lg">
                {thisWeekStudentCount}
              </span>
            </div>

            <div className="d-flex align-items-center bg-light-success rounded p-5 mb-1">
              <span className="svg-icon svg-icon-success mr-5 svg-icon-lg">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                ></SVG>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">
                  Son 30 Gün
                </span>
              </div>

              <span className="font-weight-bolder text-success py-1 font-size-lg">
                {thisMonthStudentCount}
              </span>
            </div>

            <div className="d-flex align-items-center bg-light-success rounded p-5 mb-1">
              <span className="svg-icon svg-icon-success mr-5 svg-icon-lg">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                ></SVG>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">
                  Toplam
                </span>
              </div>

              <span className="font-weight-bolder text-success py-1 font-size-lg">
                {totalStudentCount}
              </span>
            </div>

            <div className="d-flex align-items-center bg-light-success rounded p-5 mb-1">
              <span className="svg-icon svg-icon-success mr-5 svg-icon-lg">
                <SVG
                  src={toAbsoluteUrl("/media/svg/icons/General/User.svg")}
                ></SVG>
              </span>
              <div className="d-flex flex-column flex-grow-1 mr-2">
                <span className="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1">
                  {(currentActiveTerm + 1) + " - " + (currentActiveTerm + 2) + " Öğrenci Sayısı"}
                </span>
              </div>

              <span className="font-weight-bolder text-success py-1 font-size-lg">
                {nextTermStudentCount}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}